import { Admin, AdminProps, Resource } from 'react-admin';
import { DndProvider } from 'react-dnd';
import Backend from 'react-dnd-html5-backend';
import feathers from '@feathersjs/feathers';
import authenticationClient from '@feathersjs/authentication-client';
import restClient from '@feathersjs/rest-client';

import { layout, loginPage, theme } from './layout';
import { authProvider, dataProvider, i18nProvider } from './providers';
import * as resources from './resources';
import config from './config';

const app = feathers();
app.configure(restClient(config.API).fetch(window.fetch));
app.configure(authenticationClient());

const appProps: AdminProps = {
  authProvider: authProvider(app),
  dataProvider: dataProvider(app),
  i18nProvider,
  loginPage,
  theme,
  layout
};

function App() {
  return (
    <DndProvider backend={Backend}>
      <Admin {...appProps}>
        {Object.values(resources).map(resource => (
          <Resource {...resource} key={resource.name} />
        ))}
      </Admin>
    </DndProvider>
  );
}

export { app };

export default App;
